export const ADVANCED_CHART_TYPES = {
  DEMOGRAPHICS: 'demographics',
  PARTICIPANTS_OVERTIME: 'participants-overtime',
  CATEGORY_COMPARISION: 'category-comparision',
  GENDER_COMPARISION: 'gender-comparision',
  AGE_GROUP_COMPARISION: 'age-group-comparision',
  AGE_GROUP_ANSWERS: 'age-group-answers',
  GENDER_ANSWERS: 'gender-answers',
};

export const credits = {
  enabled: false,
};

export const legend = {
  verticalAlign: 'top',
  align: 'left',
  itemStyle: {
    fontSize: '10px',
  },
};

export const tooltip = {
  headerFormat:
    '<span style="z-index: 10"><span style="font-size:10px">{point.key}</span><table>',
  formatter: function() {
    const headerFormat = `<span style="z-index: 10"><span style="font-size:10px">${this.key}</span><table>`;
    const footerFormat = '</table></span>';
    const pointFormat = `<tr><td style="color:${this.series.color};padding:0">${
      this.series.name
    }: </td>
    <td style="padding:0"><b>${Math.abs(this.point.y)}</b></td></tr>`;

    return headerFormat + pointFormat + footerFormat;
  },
  footerFormat: '</table></span>',
  useHTML: true,
};

export const plotOptions = {
  column: {
    pointPadding: 0,
    borderWidth: 0,
    dataLabels: {
      enabled: true,
    },
  },
};

export const title = {
  align: 'left',
  style: {
    color: '#29508B',
    fontSize: '14px',
    fontWeight: 600,
  },
};

export const subtitle = {
  align: 'left',
  style: {
    color: '#4F6F9F',
  },
};

export const pieChartConfig = {
  innerSize: '60%',
  showInLegend: true,
  dataLabels: {
    enabled: true,
    distance: -25,
    formatter: function() {
      return this.y + '%';
    },
  },
  states: {
    hover: {
      enabled: false,
    },
  },
  point: {
    events: {
      legendItemClick: function() {
        return false;
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants/chartsConstants.js